import { useQuery } from '@tanstack/react-query';

import { api } from 'utils/axios';
import useUrlParams from 'utils/urlParms';

const GET_VISA_APPLICANTS_QUERY = 'get-visa-applicants';

const getVisaApplicants = async (params) => {
  try {
    const response = await api.get(`/visaApplicant`, { params });
    return response.data;
  } catch (e) {
    console.error(e, 'Error fetching Visas');
  }

};

const useGetVisaApplicants = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_VISA_APPLICANTS_QUERY, params],

    queryFn: () => getVisaApplicants(params),
  });
};

export { useGetVisaApplicants, GET_VISA_APPLICANTS_QUERY };
